import moment from "moment";
import { REPORTS_DISCOUNT_SLAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Discount Program Code",
    field: "discountProgramCode",
    locked: true,
    hide: false,
    cellClass: "custom-ag-cell-link",
    width: 200,
    suppressMovable: true,
  },
  {
    headerName: "Discount Program Name",
    field: "programName",
    locked: true,
    hide: false,
    width: 200,
  },
  {
    headerName: "Program Start Date",
    field: "startDate",
    locked: true,
    hide: false,
    width: 180,
  },
  {
    headerName: "Program End Date",
    field: "endDate",
    locked: true,
    hide: false,
    width: 180,
  },
  {
    headerName: "Branches",
    field: "branchCode",
    locked: false,
    hide: false,
    width: 350,
  },
  {
    headerName: "Status",
    field: "deleted",
    locked: false,
    hide: false,
    width: 120,
  },
  {
    headerName: "Created Date",
    field: "createdTime",
    locked: false,
    hide: false,
    width: 180,
  },
  {
    headerName: "Created By",
    field: "createdBy",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Updated Date",
    field: "updatedTime",
    locked: false,
    hide: false,
    width: 180,
  },
  {
    headerName: "Updated By",
    field: "updatedBy",
    locked: false,
    hide: false,
    width: 150,
  },
  {
    headerName: "Company",
    field: "company",
    locked: false,
    hide: false,
    width: 150,
  },
];
export const columnDefsFunctions = {
  startDate: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  endDate: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY");
    },
  },
  deleted: {
    valueFormatter: (params) => {
      return params.value === true ? "INACTIVE" : "ACTIVE";
    },
    filterValueGetter: (params) => {
      return params.data?.deleted === true ? "INACTIVE" : "ACTIVE";
    },
    cellStyle: (params) => {
      return {
        borderRight: "1px solid #a0a0a0",
        ...(params.value === true && { color: "red" }),
        ...(params.value === false && { color: "green" }),
      };
    },
  },
};

export const initial_state_discount_slab_report = {
  type: REPORTS_DISCOUNT_SLAB,
  label: "Discount Program Report",
  allowMultipleTabs: false,
};
